
import Vue, { PropType } from "vue";

export default Vue.extend({
  props: {
    options: {
      required: false,
      type: Array as PropType<any[]>,
      default: () => [],
    },
    selection: {
      required: false,
      type: Number,
      default: 0,
    },
    arialabel: {
      required: false,
      type: String,
      default: "Select an option",
    },
  },
  data() {
    return {
      isOpen: false as boolean,
      selected: 0 as number,
    };
  },
  mounted() {
    this.selected = this.selection ? this.selection : 0;
  },
  watch: {
    selection() {
      this.selected = this.selection ? this.selection : 0;
    },
  },
  methods: {
    onShow() {
      this.isOpen = !this.isOpen;
    },
    close() {
      this.isOpen = false;
    },
    onSelect(id: number): void {
      this.selected = id - 1;
      this.isOpen = false;
      this.$emit("selectOption", id);
    },
  },
});
